import { ApiStatusError } from "@/lib/api";
import { useToastStore } from "@/stores/useToastStore";

/**
 * 待たない操作の境界。失敗をトーストで知らせ、元のエラーをログに出して終える (投げ直さない)。API の失敗はその理由を
 * (まとめた失敗なら最初の API の失敗の理由を)、それ以外は context を出す。同じ文言のトーストを出している間は重ねない
 * (ポーリングが続けて失敗したときなど)。
 */
export function reportSharedVolumeFailure(promise: Promise<unknown>, context: string): void {
	void promise.catch((err: unknown) => {
		const reasons: unknown[] = err instanceof AggregateError ? err.errors : [err];
		const apiError = reasons.find((reason) => reason instanceof ApiStatusError);
		const message = apiError instanceof ApiStatusError ? apiError.message : context;
		const toasts = useToastStore.getState();
		if (!toasts.toasts.some((toast) => toast.type === "error" && toast.message === message)) {
			toasts.show({ type: "error", message });
		}
		console.error(context, err);
	});
}
